// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'newbuilding-promos-search-frontend';

export const NEWBUILDING_DESKTOP_BASE_QUERY_URL_CONFIG_KEY =
  'newbuilding-promos-search-frontend.newbuildingListing.desktopBaseQueryUrl';
export const NEWBUILDING_MOBILE_BASE_QUERY_URL_CONFIG_KEY =
  'newbuilding-promos-search-frontend.newbuildingListing.mobileBaseQueryUrl';
export const OFFERS_BASE_QUERY_URL_CONFIG_KEY = 'newbuilding-promos-search-frontend.offersListing.baseQueryUrl';
export const CIAN_MORTGAGE_URL_CONFIG_KEY = 'newbuilding-promos-search-frontend.cianMortgageUrl';

export const UNIQUE_PROMO_ID_QUERY_PARAM_CONFIG_KEY = 'newbuilding-promos-search-frontend.uniquePromoIdQueryParam';
